import React, { Component } from 'react'

import InsightsEvalFormHeader from './InsightsEvalFormHeader';
import InsightsEvalFormFooter from './InsightsEvalFormFooter';
import InsightsEvalFormNavigationButtons from './InsightsEvalFormNavigationButtons';

import PurchasePriceInput from './UiElements/PurchasePriceInput';


class InsightsPurchasePriceForm extends Component {
  state = {
    submitButtonClicked: false,
  }


  handleSubmit = e => {
    e.preventDefault();
    this.setState({
      submitButtonClicked: true
    })

    // Allow the next step if there are either no errors or the (optional) field is empty
    if (this.props.errors.purchasePrice !== true || this.props.values.purchasePrice === "" || (typeof(this.props.values.purchasePrice) === 'number' && isNaN(this.props.values.purchasePrice))) {
      this.props.nextStep();
    }
  }


  render() {
    const analysis = this.props.analysis;
    const purchasePriceError = this.props.errors.purchasePrice;

    return (
      <div>

        <InsightsEvalFormHeader />

        <div className="container">

          <div className="row">
            <div className="col s12">
              <h5>Kaufpreis</h5>
            </div>
          </div>

          <div className="insights-eval-form-content">

            <div className="row">
              <div className="col s12">
                <PurchasePriceInput
                  handleChange={this.props.handleChange}
                  handleSubmit={this.handleSubmit}
                  values={this.props.values}
                />
              </div>
              <span className="grey-text">Oder weiter zur nächsten Seite</span>
              { this.state.submitButtonClicked && purchasePriceError ? <div className="col s12"><span className="helper-text" style={{color: "red"}}>Bitte geben Sie einen gültigen Kaufpreis ein.</span></div> : null }
            </div>

          </div>

          <div className="row">
            <div className="col s12">
              <InsightsEvalFormNavigationButtons
                previousStep={this.props.previousStep}
                skipToEnd={this.props.skipToEnd}
                handleSubmit={this.handleSubmit}
                deactivateSubmitButton={this.state.submitButtonClicked && (typeof(this.props.values.purchasePrice) === 'number' && isNaN(this.props.values.purchasePrice) === false) && purchasePriceError}
                analysis={analysis}
                />
            </div>
          </div>

        </div>

        <div className="divider" />
        <div className="row">
          <div className="col s12">
            <InsightsEvalFormFooter
              previousStep={this.props.previousStep}
              skipToEnd={this.props.skipToEnd}
              handleSubmit={this.handleSubmit}
              analysis={analysis}
              />
          </div>
        </div>

      </div>
    )
  }
}

export default InsightsPurchasePriceForm;
